import { useState, useEffect } from 'react';
import PantrySection from '@/components/PantrySection';
import MobilePantry from '@/components/MobilePantry';
import PantryWasteControls from '@/components/PantryWasteControls';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Package, Settings2 } from 'lucide-react';

const Pantry = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [activeTab, setActiveTab] = useState('items');
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return <MobilePantry />;
  }

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-semibold font-['Playfair_Display']">Pantry</h1>
            <TabsList>
              <TabsTrigger value="items" className="flex items-center gap-2">
                <Package className="w-4 h-4" />
                My Items
              </TabsTrigger>
              <TabsTrigger value="controls" className="flex items-center gap-2">
                <Settings2 className="w-4 h-4" />
                Smart Controls
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="items">
            <PantrySection />
          </TabsContent>

          <TabsContent value="controls">
            <PantryWasteControls />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Pantry;
